import { useState } from 'react'
import { ReactComponent as LirariLogoBackground } from '../../assets/images/lirari-logo-background.svg'
import { Offering } from '../../Api/Lirari/Types/offering'
import { Genre } from '../../Api/Lirari/Types/genre'
import userClient from '../../Api/Lirari/Clients/userClient'
import { useAuth0 } from '@auth0/auth0-react'
import React from 'react'
import { User } from '../../Api/Lirari/Types/user'
import LocationModal from './locationModal'
import UsersList from './usersList'
import SearchComponents from './searchComponents'
import { useAtom } from 'jotai'
import { genresAtom } from '../../State/Musician/genresAtom'
import { ReactComponent as LirariLogoSmall } from '../../assets/images/lirari-logo-small-italic.svg'
import { offeringsAtom } from '../../State/Musician/offeringsAtom'

export interface LocationType {
  type: string // "Point"
  coordinates: [number, number] // [longitude, latitude]
}

const SearchPage = () => {
  const [users, setUsers] = React.useState<User[]>([])
  const [selectedGenres, setSelectedGenres] = useState<Genre[]>([])
  const [selectedOfferings, setSelectedOfferings] = useState<Offering[]>([])
  const [searchInput, setSearchInput] = useState('')
  const [location, setLocation] = useState<LocationType>()
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false)
  const [genres] = useAtom(genresAtom)
  const [offerings] = useAtom(offeringsAtom)

  const { isAuthenticated, getAccessTokenSilently } = useAuth0()

  React.useEffect(() => {
    if (searchInput || selectedGenres || selectedOfferings || location) {
      ;(async () => {
        if (isAuthenticated) {
          const token = await getAccessTokenSilently({
            authorizationParams: {
              scope: 'user:all',
            },
          })

          const response = await userClient.searchUsers(
            {
              search: searchInput,
              genres: selectedGenres.map((genre) => genre.id),
              offerings: selectedOfferings.map((offering) => offering.id),
              longitude: location ? location.coordinates[0] : 35.2034184,
              latitude: location ? location.coordinates[1] : 31.9037641,
            },
            token,
          )

          setUsers(response ?? [])
        }
      })()
    }
  }, [selectedGenres, getAccessTokenSilently, isAuthenticated, location, selectedOfferings, searchInput])

  return (
    <div className="relative lg:flex lg:flex-row min-w-screen min-h-screen bg-[#242424]">
      <LirariLogoBackground className="fixed top-5 w-full h-full z-0" />
      {genres.length > 0 ? (
        <SearchComponents
          genres={genres}
          offerings={offerings}
          selectedGenres={selectedGenres}
          selectedOfferings={selectedOfferings}
          searchInput={searchInput}
          setSelectedGenres={setSelectedGenres}
          setSelectedOfferings={setSelectedOfferings}
          setIsLocationModalOpen={setIsLocationModalOpen}
          setSearchInput={setSearchInput}
        />
      ) : null}
      {isLocationModalOpen ? (
        <LocationModal setLocation={setLocation} setIsLocationModalOpen={setIsLocationModalOpen} />
      ) : null}
      {users.length > 0 ? (
        <UsersList users={users} />
      ) : (
        <div className="px-2">
          <div className="flex lg:mt-8 lg:ml-5 h-60 lg:w-[335px] w-full items-center justify-center backdrop-blur-sm bg-gradient-to-b from-[#BE7F7F] to-[#242424] rounded-lg">
            <LirariLogoSmall className="scale-x-[-1]" />
            <p className="whitespace-break-spaces w-min	text-center text-2xl">No Matches</p>
            <LirariLogoSmall />
          </div>
        </div>
      )}
    </div>
  )
}

export default SearchPage
